<template>
    <div class="mb-4">
        <gamification-arrow
            class="ml-4 mr-4"
            :value="contentText"
            :color="color"
        />
        <i
            class="mdi mdi-share mdi-rotate-270 mdi-48px"
            :style="{color: color.primary}"
        ></i>
        <gamification-box
            class="mt-4"
            :value="pointsText"
            :color="color"
            :style="{maxWidth: '107px', marginLeft: '77px'}"
        />
    </div>
</template>
<script>
import GamificationArrow from './GamificationArrow';
import GamificationBox from './GamificationBox';

export default {
    name: 'GamificationContentPoints',

    props: {
        contentText: String,
        pointsText: String,
        color: {
            type: Object,
            required: true,
        },
    },

    components: {
        GamificationArrow,
        GamificationBox,
    }
};
</script>
    
<style scoped>
    .mdi-share {
        margin-top: -30px;
        position: absolute;
        color: #000;
        margin-left: 40px;
    }
</style>
    